export default {
  UPDATE_USER_CURRENT_SESSION: 'UPDATE_USER_CURRENT_SESSION',
  CLEAR_USER_INFO: 'CLEAR_USER_INFO',
  UPDATE_USER_DATA_FROM_TOKEN: 'UPDATE_USER_DATA_FROM_TOKEN',
};
